export default "__VITE_ASSET__BqzsuVV7__"